<ng-container *ngIf="dashboard.length > 0 && !loader"
  ><div
    *ngFor="let score of dashboard; let i = index"
    infinite-scroll
    [infiniteScrollDistance]="scrollDistance"
    [infiniteScrollThrottle]="throttle"
    (scrolled)="loadDashboard()"
  >
    <app-expansion-panel
      [isOpen]="filterSelected != 'All' ? true : score.active"
    >
      <div
        expansion-panel-header
        class="grid grid-cols-5 gap-5 bg-red-4 text-grey-1 mt-4 p-4 max-sm:py-3 max-sm:px-2 rounded-5 items-center max-sm:mt-2"
      >
        <div class="flex items-center gap-4 col-span-3 max-sm:gap-1">
          <img
            alt="logo"
            class="w-[40px] h-[40px] max-sm:w-[20px] max-sm:h-[20px] cursor-pointer border border-grey-7 border-solid rounded-full object-contain"
            [src]="
              score.country.hasCountry
                ? score.country.countryLogo != ''
                  ? score.country.countryLogo
                  : urlIMG + 'default.png'
                : score.competitionLogo
                ? score.competitionLogo
                : urlIMG + 'default.png'
            "
          />
          <a
            class="font-roboto-600 text-18 max-sm:text-11 hover:underline cursor-pointer"
            [routerLink]="[score.link]"
          >
            {{ !(score.country.country && score.competitionName) ? "NA" : "" }}
            {{ score.country.hasCountry ? score.country.country + " -" : "" }}
            <span class="font-roboto-400">{{
              score.competitionName +
                (score.stageData && score.stageData.name
                  ? utilityService.lowerCase(score.stageData.name) !=
                      "league" &&
                    utilityService.lowerCase(score.stageData.name) != "leauge"
                    ? " - " + (score.stageData.name | translate)
                    : ""
                  : "")
            }}</span>
          </a>
        </div>

        <div class="flex justify-end gap-4 col-span-2 max-sm:gap-2">
          <!-- TODO: delete favorito -->
          <!-- <img
            alt="logo"
            [src]="urlIcon + (score.favorite ? 'fav-red.svg' : 'fav-grey.svg')"
            class="max-sm:w-[16px] cursor-pointer"
            (click)="$event.stopPropagation(); favoriteCompetition(score)"
          /> -->
          <div
            class="text-nowrap justify-center px-3 py-1 max-sm:px-2 bg-white font-roboto-400 max-sm:text-10 rounded-[100px]"
          >
            {{ "Matches" | translate }} ({{ score.results.length }})
          </div>
          <img
            alt="logo"
            [src]="urlIcon + 'arrow-down-red.svg'"
            class="max-sm:w-[7px]"
          />
        </div>
      </div>

      <div expansion-panel-content>
        <a
          [routerLink]="[match.link]"
          *ngFor="let match of score.results; let i = index"
          class="grid grid-cols-12 max-sm:gap-4 bg-white my-4 px-4 py-3 max-sm:py-2 max-sm:px-2 rounded-6 min-h-[90px] max-sm:min-h-[60px] items-center text-grey-2 font-Roboto-400 text-17 max-sm:text-12 max-sm:my-2 cursor-pointer"
        >
          <div
            class="flex items-center justify-between gap-1 col-span-7 max-sm:hidden"
          >
            <!-- Home Team -->
            <div class="flex items-center gap-2 flex-1 min-w-0">
              <img
                alt="logo"
                class="logo-sm"
                [src]="
                  match.homeTeam.logo
                    ? match.homeTeam.logo
                    : urlIMG + 'default.png'
                "
              />
              <a
                class="hover:underline cursor-pointer text-wrap truncate"
                [routerLink]="[match.homeTeam.link]"
                [ngClass]="{
                  'font-roboto-500':
                    match.statusId === 100 &&
                    match.homeScores.scoreFinal > match.awayScores.scoreFinal
                }"
                >{{ match.homeTeam.name ? match.homeTeam.name : "NA" }}</a
              >
            </div>

            <!-- VS or Scores -->
            <div
              *ngIf="!(match.statusId === 2 || match.statusId === 100)"
              class="flex-none w-[50px] max-sm:w-[30px] vs-container relative font-roboto-500 text-blue text-14 max-sm:text-10 pl-4 pr-10"
            >
              <span class="absolute bg-white content">VS</span>
            </div>
            <div
              *ngIf="match.statusId === 2 || match.statusId === 100"
              [ngClass]="{
                'text-blue-o-50 font-inter-700': match.statusId === 100,
                'text-red-2 font-inter-600': match.statusId !== 100
              }"
              class="flex-none w-[64px] max-sm:w-[30px] py-1 max-sm:py-[0.7px] text-center rounded-[16px] text-14 max-sm:text-10 bg-red-4"
            >
              {{ match.homeScores.scoreFinal }} -
              {{ match.awayScores.scoreFinal }}
            </div>

            <!-- Away Team -->
            <div
              class="flex items-center gap-2 flex-1 min-w-0 flex-row-reverse justify-start"
            >
              <img
                alt="logo"
                class="logo-sm"
                [src]="
                  match.awayTeam.logo
                    ? match.awayTeam.logo
                    : urlIMG + 'default.png'
                "
              />
              <a
                class="hover:underline cursor-pointer text-wrap truncate text-end"
                [ngClass]="{
                  'font-roboto-500':
                    match.statusId === 100 &&
                    match.awayScores.scoreFinal > match.homeScores.scoreFinal
                }"
                [routerLink]="[match.awayTeam.link]"
                >{{ match.awayTeam.name ? match.awayTeam.name : "NA" }}</a
              >
            </div>
          </div>

          <div class="hidden flex-col gap-1 col-span-7 max-sm:flex">
            <!-- Home Team -->
            <div class="grid grid-cols-5 items-center">
              <div class="flex items-center gap-2 min-w-0 col-span-4">
                <img
                  alt="logo"
                  class="logo-sm"
                  [src]="
                    match.homeTeam.logo
                      ? match.homeTeam.logo
                      : urlIMG + 'default.png'
                  "
                />
                <a
                  class="hover:underline cursor-pointer text-wrap truncate"
                  [routerLink]="[match.homeTeam.link]"
                  [ngClass]="{
                    'font-roboto-500':
                      match.statusId === 100 &&
                      match.homeScores.scoreFinal > match.awayScores.scoreFinal
                  }"
                  >{{ match.homeTeam.name ? match.homeTeam.name : "NA" }}</a
                >
              </div>
              <div
                *ngIf="[2, 100].includes(match.statusId)"
                class="font-inter-600 text-14 max-sm:text-10 text-end"
                [ngClass]="{
                  'font-inter-700':
                    match.statusId === 100 &&
                    match.homeScores.scoreFinal > match.awayScores.scoreFinal
                }"
              >
                {{ match.homeScores.scoreFinal }}
              </div>
            </div>

            <!-- Away Team -->
            <div class="grid grid-cols-5 items-center">
              <div class="flex items-center gap-2 flex-1 min-w-0 col-span-4">
                <img
                  alt="logo"
                  class="logo-sm"
                  [src]="
                    match.awayTeam.logo
                      ? match.awayTeam.logo
                      : urlIMG + 'default.png'
                  "
                />
                <a
                  class="hover:underline cursor-pointer text-wrap truncate"
                  [ngClass]="{
                    'font-roboto-500':
                      match.statusId === 100 &&
                      match.awayScores.scoreFinal > match.homeScores.scoreFinal
                  }"
                  [routerLink]="[match.awayTeam.link]"
                  >{{ match.awayTeam.name ? match.awayTeam.name : "NA" }}</a
                >
              </div>
              <div
                *ngIf="[2, 100].includes(match.statusId)"
                class="font-inter-600 text-14 max-sm:text-10 text-end"
                [ngClass]="{
                  'font-inter-700':
                    match.statusId === 100 &&
                    match.awayScores.scoreFinal > match.homeScores.scoreFinal
                }"
              >
                {{ match.awayScores.scoreFinal }}
              </div>
            </div>
          </div>

          <!-- <div
            class="grid grid-cols-2 max-md:grid-cols-1 max-md:gap-2 max-sm:gap-1 col-span-4 max-sm:col-span-3 max-sm:text-10"
          > -->
          <div
            class="flex gap-3 max-sm:gap-2 items-center justify-center col-span-3 max-sm:col-span-2 max-sm:text-10"
            [ngClass]="{
              'text-red-2 font-roboto-500 efect-inlive': match.statusId === 2,
              'font-roboto-500': match.statusId === 100
            }"
          >
            <img
              alt="logo"
              *ngIf="match.statusId === 1"
              class="cursor-pointer"
              [src]="urlIcon + 'clock-grey.svg'"
              class="max-sm:w-[16px]"
            />
            {{
              match.statusId === 1
                ? match.matchTime
                : match.statusId === 2
                ? match.score.matchTimeCurrent
                  ? match.status + "&#13;&#10;" + match.score.matchTimeCurrent
                  : match.status
                : match.status
            }}
          </div>

          <!-- <div class="flex gap-3 max-sm:gap-2 items-center justify-center">
              <img alt="logo"
                class="cursor-pointer"
                [src]="urlIcon + 'location-grey.svg'"
                class="max-sm:w-[16px]"
              />London
            </div>
          </div> -->

          <div
            class="flex gap-2 max-sm:gap-1 justify-between col-span-2 max-sm:col-span-3"
          >
            <div *ngIf="!(match.statusId > 1 && match.statusId < 8)"></div>
            <!-- TODO: delete favorito -->
            <!-- <img
              alt="logo"
              class="cursor-pointer max-sm:w-[15px]"
              [src]="
                urlIcon + (match.favorite ? 'fav-red.svg' : 'fav-grey.svg')
              "
              (click)="
                $event.stopPropagation();
                favoriteMatch(match, score.idCompetition)
              "
            /> -->
            <img
              alt="logo"
              *ngIf="match.statusId > 1 && match.statusId < 8"
              class="cursor-pointer max-sm:w-[15px]"
              [src]="urlIcon + 'graph.svg'"
              [routerLink]="[
                '/' + sportsServices.getSelectedSport() + '/match-odds'
              ]"
            />
            <img
              alt="logo"
              [src]="urlIcon + 'share-grey.svg'"
              class="max-sm:w-[16px] cursor-pointer"
              nz-popover
              [nzPopoverVisible]="isOpen === match.id"
              nzPopoverTrigger="click"
              [nzPopoverContent]="contentTemplate"
              (click)="$event.stopPropagation(); openModal(match.id)"
              nzPopoverPlacement="bottomRight"
            />
            <ng-template #contentTemplate>
              <app-share-modal
                [link]="
                  urlApp +
                  'partido/' +
                  sportsServices.getSelectedSport() +
                  '/' +
                  match.id +
                  '/' +
                  match.homeTeam.id +
                  '/' +
                  match.awayTeam.id +
                  '/' +
                  score.idCompetition +
                  '/' +
                  this.dateSelected
                "
                (onClose)="isOpen = null"
              ></app-share-modal>
            </ng-template>
          </div>
        </a>
      </div>
    </app-expansion-panel></div
></ng-container>
